import { render, staticRenderFns } from "./roundTimeForm.vue?vue&type=template&id=87d23822&scoped=true&"
import script from "./roundTimeForm.vue?vue&type=script&lang=js&"
export * from "./roundTimeForm.vue?vue&type=script&lang=js&"
import style0 from "./roundTimeForm.vue?vue&type=style&index=0&id=87d23822&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d23822",
  null
  
)

export default component.exports